module.exports = __webpack_public_path__ + "c046dd38161e26e799993d2d6aac8ceb.pdf";